<!-- <main class="main"> -->
<!-- <div class="row">
<div class="col-lg-12 text-left mt-3">
  <button type="button" class='primary-btn mr-1 form-btn btn-save' (click)="addRow('ADD');">ADD ROW
    <i class="fa fa-floppy-o ml-3 text-white" aria-hidden="true"></i>
  </button>
</div>
</div> -->
@if (_currentData.asideGridConfig.add_required!=undefined?_currentData.asideGridConfig.add_required:true) {
  <div class="d-flex justify-content-end"
    >
    <ng-container>
      <button type="button" class="primary-btn" (click)="addRow('ADD');">
        <span>{{'Add New' | translate | async}}</span>
        <i class="fa fa-plus" aria-hidden="true"></i>
      </button>
    </ng-container>
  </div>
}
<dhs-data-grid [fields]="_currentData.currentListFields" [data]="_currentData.dataList" [bulkActionsConfig]="false"
  (bulkActionClicked)="onBulkActionClicked($event)" (bindGrid)="bindDataToGrid($event)"
  [config]="_currentData.dataGridConfig" (editEllipseClick)="setComponent($event)">
</dhs-data-grid>
@if (_currentData.dataList!=undefined &&  _currentData.dataList.resource !=undefined &&  _currentData.dataList.resource.length>0) {
  <div class="row"
    >
    <div class="col-lg-12 text-center mt-2">
      <button
        [disabled]="_currentData.asideGridConfig.submit_button!=undefined && _currentData.asideGridConfig.submit_button.disabled!=undefined?_currentData.asideGridConfig.submit_button.disabled:false"
        type="button" class='primary-btn mr-1 form-btn btn-save'
        (click)="onSubmit(_currentData.asideGridConfig.submit_button);">{{_currentData.asideGridConfig && _currentData.asideGridConfig.submit_button!=undefined && _currentData.asideGridConfig.submit_button.title!=undefined?_currentData.asideGridConfig.submit_button.title:'Submit'| translate | async  }}
        <i class="fa fa-floppy-o ml-3 text-white" aria-hidden="true"></i>
      </button>
    </div>
  </div>
}
@if (!_currentData.showAddButton) {
  <div class="cstmOverlay" id="cstmOverlay"></div>
}
<!-- </main> -->